import { validateAutomation as validateCoreAutomation } from 'dashboard/helper/validations';
import {
  getActionKeysForEvent,
  getConditionKeysForEvent,
} from './event-entity-map';

const DELAY_ACTION_ERRORS = {
  invalidDuration: 'Delay duration must be greater than zero.',
  invalidRange: 'Delay range must include valid min and max values.',
};
const EVENT_CONTEXT_ERRORS = {
  invalidCondition: 'This condition is not available for the selected event.',
  invalidAction: 'This action is not available for the selected event.',
};

const toIndexedErrors = errors => {
  const normalizedErrors = { ...errors };
  const conditionErrors = [];
  const actionErrors = [];

  Object.entries(errors).forEach(([key, value]) => {
    if (key.startsWith('condition_')) {
      conditionErrors[Number(key.replace('condition_', ''))] = value;
      delete normalizedErrors[key];
    }

    if (key.startsWith('action_')) {
      actionErrors[Number(key.replace('action_', ''))] = value;
      delete normalizedErrors[key];
    }
  });

  if (conditionErrors.length) {
    normalizedErrors.conditions = conditionErrors;
  }

  if (actionErrors.length) {
    normalizedErrors.actions = actionErrors;
  }

  return normalizedErrors;
};

const invalidDelay = action => {
  const params = action?.action_params || {};

  if (action.action_name === 'delay_next_action') {
    return Number(params.value) > 0
      ? null
      : DELAY_ACTION_ERRORS.invalidDuration;
  }

  if (action.action_name === 'delay_next_action_range') {
    const minValue = Number(params.min_value);
    const maxValue = Number(params.max_value);

    if (minValue > 0 && maxValue > 0) {
      return null;
    }

    return DELAY_ACTION_ERRORS.invalidRange;
  }

  return null;
};

const addEventSpecificConditionErrors = (automation, conditionErrors) => {
  const allowedConditionKeys = getConditionKeysForEvent(automation.event_name);
  (automation.conditions || []).forEach((condition, index) => {
    if (
      condition?.attribute_key &&
      !allowedConditionKeys.includes(condition.attribute_key) &&
      !conditionErrors[index]
    ) {
      conditionErrors[index] = EVENT_CONTEXT_ERRORS.invalidCondition;
    }
  });
};

const addEventSpecificActionErrors = (automation, actionErrors) => {
  const allowedActionKeys = getActionKeysForEvent(automation.event_name);
  (automation.actions || []).forEach((action, index) => {
    if (
      action?.action_name &&
      !allowedActionKeys.includes(action.action_name) &&
      !actionErrors[index]
    ) {
      actionErrors[index] = EVENT_CONTEXT_ERRORS.invalidAction;
    }
  });
};

export const validateAutomation = automation => {
  const normalizedErrors = toIndexedErrors(validateCoreAutomation(automation));
  const conditionErrors = normalizedErrors.conditions || [];
  const actionErrors = normalizedErrors.actions || [];

  (automation.actions || []).forEach((action, index) => {
    const error = invalidDelay(action);
    if (error) {
      actionErrors[index] = error;
    }
  });

  addEventSpecificConditionErrors(automation, conditionErrors);
  addEventSpecificActionErrors(automation, actionErrors);

  if (conditionErrors.length) {
    normalizedErrors.conditions = conditionErrors;
  }

  if (actionErrors.length) {
    normalizedErrors.actions = actionErrors;
  }

  return normalizedErrors;
};
